var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3218 1L33 11.1298V50H13.3218M13.3218 1L1 3.35577V50H13.3218M13.3218 1V50M6.70115 9.95192V41.5192",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1078 25H41.8469C44.2399 25.1647 53.0372 41.517 46.8139 44.5243C43.818 44.9405 41.9646 43.5615 38.2991 37.7659H27.3009C24.5383 42.1777 21.1137 46.4534 18.4313 44.5243C15.749 42.5953 16.4104 31.1801 24.1078 25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8174 31.5707H23.7531M25.8817 30.4443V29.5056M26.9461 31.5707H28.0104M25.8817 32.6971V33.6358M41.8469 25H24.1078C16.4104 31.1801 15.749 42.5953 18.4313 44.5243C21.1137 46.4534 24.5383 42.1777 27.3009 37.7659H38.2991C41.9646 43.5615 43.818 44.9405 46.8139 44.5243C53.0372 41.517 44.2399 25.1647 41.8469 25Z",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.4475,
    cy: 31.6615,
    rx: 0.885781,
    ry: 0.942308,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.2191,
    cy: 33.5462,
    rx: 0.885781,
    ry: 0.942308,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9907,
    cy: 31.6615,
    rx: 0.885781,
    ry: 0.942308,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.2191,
    cy: 29.7769,
    rx: 0.885781,
    ry: 0.942308,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/console.954082788dafa3171b53cd39ffb7b6ec.svg";
export { ForwardRef as ReactComponent };